export const EVENT_HUB_TABS = [
    { key: 'description', path: '', labelKey: 'DESCRIPTION' },
    { key: 'divisions', path: 'divisions', labelKey: 'DIVISIONS' },
    { key: 'workouts', path: 'workouts', labelKey: 'WORKOUTS' },
    { key: 'planning', path: 'planning', labelKey: 'PLANNING' },
    // fullWidth: the leaderboard spans the whole content row, no side panel (Figma 3790:33288).
    { key: 'leaderboard', path: 'leaderboard', labelKey: 'LEADERBOARD', fullWidth: true },
    { key: 'gallery', path: 'gallery', labelKey: 'GALLERY' },
    { key: 'reviews', path: 'reviews', labelKey: 'REVIEWS' },
]

/** True when the current hub route is a tab flagged `fullWidth` (drops the sidebar column). */
export const isFullWidthTabPath = (pathname = '') => {
    const lastSegment = pathname.replace(/\/+$/, '').split('/').pop()
    return EVENT_HUB_TABS.some((tab) => tab.fullWidth && tab.path === lastSegment)
}
